import React, { FC, PropsWithChildren } from 'react';
import styles from './styles.sass';

/**
 * Shared wrapper for the mating forms content area.
 *
 * @param children Form content rendered inside the shared container.
 * @returns The mating form wrapper.
 */
export const AnimalsFormContainer: FC<PropsWithChildren> = ({
  children
}) => <span className={styles.container} data-test-id="animals-form" data-sentry-component="AnimalsFormContainer" data-sentry-source-file="animals-form-container.tsx">
        {children}
    </span>;